import React from 'react';
import { View } from 'react-native';
import { useThemedStyles } from '../../hooks/useThemedStyles';

export const Separator = ({ style }) => {
	const styles = useThemedStyles(createStyles);

	return (
		<View style={[styles.separator, style]} />
	);
};

const createStyles = ({ ui: { colors } }) => ({
	separator: {
		borderColor: colors.border,
		borderBottomWidth: 1,
		marginTop: 4,
		marginBottom: 4,
	},
});

